import { render } from "./Menu.vue?vue&type=template&id=7e04caec&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=7e04caec&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-7e04caec"

export default script